import {isNil} from 'ramda'
export type AskedType = 'string' | 'number' | 'array' | 'boolean'

type TypeMap = {
  string: string
  number: number
  array: unknown[]
  boolean: boolean
}

const types = {
  string: (val: unknown): string => {
    let res = ''

    try {
      res = val.toString()
    } catch {} // eslint-disable-line no-empty

    return res
  },

  number: (val: unknown, rejectNaN: boolean): number => {
    const num = Number.parseFloat(val as string)
    const fallback = rejectNaN ? undefined : 0
    return Number.isNaN(num) ? fallback : num
  },

  array: (val: unknown): unknown[] => {
    if (isNil(val)) return []
    if (Array.isArray(val)) return val
    if (typeof val !== 'string') return [val]
    return val.split(',').map(x => x.trim())
  },

  boolean: (val: unknown) => {
    if (val === '0') return false

    return Boolean(val)
  }
}

const typeCast = <T extends AskedType>(
  val: unknown,
  type: T,
  rejectNaN?: boolean
): TypeMap[T] | null | undefined => {
  const fn = types[type]

  if (typeof fn !== 'function') throw new Error('cannot cast to ' + type)

  return fn(val, rejectNaN) as TypeMap[T]
}

export default typeCast
